import { useTranslation } from "react-i18next";

import type { SalesListSortValue } from "../types";

type SortByOptions = {
  value: SalesListSortValue;
  label: string;
};

export const useSortByOptions = (): SortByOptions[] => {
  const { t } = useTranslation("users", {
    keyPrefix: "salesListPage.salesListTable.filters.sortByOptions"
  });

  return [
    {
      value: "newest",
      label: t("newest")
    },
    {
      value: "oldest",
      label: t("oldest")
    }
  ];
};
